import {isNil} from "lodash";

export default class FileWorkerQueueHandler {
    queuedCallbacks: Function[] = [];
    currentlyHandlingCallbacks: number = 0;

    constructor() {
        this.handleQueue();
    }

    addCallbackToQueue(callback: Function) {
        this.queuedCallbacks.push(callback);
    }

    handleQueue() {
        setInterval(() => {
            if (this.queuedCallbacks.length === 0 || this.currentlyHandlingCallbacks >= 5) {
                return;
            }

            this.currentlyHandlingCallbacks++;
            const cb = this.queuedCallbacks.shift();

            if (isNil(cb)) {
                return;
            }

            cb(() => {
                this.finishCallback();
            });
        }, 100);
    }

    finishCallback() {
        --this.currentlyHandlingCallbacks;
    }
}
